import {Observable, Subscription} from 'rxjs';

import IVolumeStore from '../Interfaces/IVolumeStore';

const subscribeToVolumeSliderDrag = (
    volumeSliderDrag$: Observable<number>,
    volumeStore: IVolumeStore
): Subscription =>
    volumeSliderDrag$
        .subscribe((multiplier) => volumeStore.actions.dragToSetLevel(multiplier));

export default subscribeToVolumeSliderDrag;